import { IQueryParameters } from 'common/models';
import API from 'services/api';

export const getPropertiesLite = ({ params }: IQueryParameters) =>
  API.get('/api/renter/accommodation/properties', {
    params: { ...params },
  }).then(response => response?.data);
